<template>
  <component
    :is="isFiteApp ? 'radio' : 'a'"
    :id="isFiteApp ? `category_${category.id}` : null"
    :href="categorySlug"
    :class="{
      'category-item-fi': true,
      'category-item-fi--disabled': !category.enabled,
      'category-item-fi--fite': isFiteApp,
      'category-item-fi--selected': category.selected,
    }"
    :checked="isFiteApp && category.enabled"
    data-test="search-result-category"
    @click.capture.stop="onClick"
  >
    <ssr-cloud-image-fi
      v-if="isFiteApp"
      class="category-item-fi__img"
      :src="category.imageUrl"
      :breakpoints="[
        {
          mediaWidth: 1024,
          imageWidth: 422,
        },
      ]"
      :unlimited="353"
      :aspect-ratio="16 / 9"
    />
    <component
      :is="isFiteApp ? 'label' : 'span'"
      :for="isFiteApp ? `category_${category.id}` : null"
      class="category-item-fi__category"
      data-test="search-result-category-name"
      :class="{
        'category-item-fi__category--selected': category.selected,
        'category-item-fi__category--disabled': !category.enabled,
      }"
    >
      {{ category.name }}
    </component>
    <icon-fi
      v-if="isFiteApp"
      :icon="category.selected ? 'radio-btn-on' : 'radio-btn-off'"
      :class="{
        'category-item-fi__checkbox': true,
        'category-item-fi__checkbox--selected': category.selected,
        'category-item-fi__checkbox--disabled': !category.enabled,
      }"
    />
    <div
      v-else
      class="category-item-fi__icon"
    >
      <arrow-icon />
    </div>
  </component>
</template>

<script setup lang="ts">
import { ArrowIcon, IconFi, SsrCloudImageFi } from 'atoms';
import { computed } from 'vue';

import type { BreadCrumbItem } from '@/components/atoms/breadcrumb-fi/BreadcrumbFi.vue';
import { useEventHub } from '@/composables/eventHub';
import { useFischer } from '@/composables/fischerPlugin';
import { useNavigationStore } from '@/store/pinia/navigation';

import type { Category } from './FactFinderCategories.vue';

const navigationStore = useNavigationStore();
const fischer = useFischer();
const { sendClickToEventHub } = useEventHub();
const isFiteApp = fischer.app.isFite();

const props = defineProps<{
  category: Category;
  filterUrlParams: string;
}>();

const emits = defineEmits<{
  toggle: [value: boolean];
}>();

const categorySlug = computed<string | undefined>(() => {
  if (!props.category.enabled || isFiteApp) {
    return undefined;
  }
  const products = fischer.pages.products().url;
  return `${products}${props.category.Slug}${props.filterUrlParams}`;
});

const onClick = (event: MouseEvent) => {
  if (!props.category.enabled || event.detail === 2) {
    return;
  }
  if (isFiteApp) {
    event.preventDefault();
    emits('toggle', !props.category.selected);
    return;
  }
  if (!categorySlug.value) {
    console.error('missing category slug');
    return;
  }
  const productBreadcrumb = navigationStore.productBreadcrumb;
  const breadcrumb = productBreadcrumb.map((item: BreadCrumbItem) => item.title);
  breadcrumb.unshift('[category]:');
  breadcrumb.push(props.category.name);
  const eventQuery = breadcrumb.join('/');
  sendClickToEventHub(
    {
      clickSource: 'category',
      familyId: props.category.id,
      pageTitle: props.category.name,
      query: eventQuery,
      url: window.location.href,
    },
    event,
    categorySlug.value,
  );
};
</script>

<style scoped src="./category-item-fi" />
